import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import { EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS } from "~/store/action_types";
import { editProjectTemplateElement } from "~/store/actions/actions.projectTemplateElements";
import { updateSubscribers } from "~/store/actions/actions.subscription";
import { getProjectTemplateElementById } from "~/store/selectors/selector.projectTemplateElements";
import { getSubscriberIdsByTypeAndId } from "~/store/selectors/selector.subscription";
import { TemplateTaskForm } from "./TemplateTaskForm";

export const TemplateTaskEditForm = ({ taskId, templateId }) => {
  const dispatch = useDispatch();

  const task = useSelector((state) => getProjectTemplateElementById(state, taskId));
  const location = useLocation();
  const navigate = useNavigate();

  const initialSubscriberIds = useSelector((state) => getSubscriberIdsByTypeAndId(state, task.class, taskId));

  const handleCancel = useCallback(() => {
    navigate(location.pathname + location.search, { replace: true, state: null });
  }, [location.pathname, location.search, navigate]);

  const handleSubmit = useCallback(
    async (updates) => {
      const first = [...updates.subscribers].sort();
      const second = [...initialSubscriberIds].sort();
      if (!isEqual(first, second)) {
        dispatch(updateSubscribers(taskId, task.class, updates.subscribers));
      }
      await dispatch(editProjectTemplateElement(taskId, templateId, { ...task, ...updates })).then((response) => {
        if (response.type === EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS) {
          return handleCancel();
        }
      });
    },
    [dispatch, handleCancel, initialSubscriberIds, task, taskId, templateId]
  );

  return (
    <TemplateTaskForm
      initialState={{
        ...task,
        subscribers: initialSubscriberIds || [],
        attachmentIds: task.attachments,
        attachments: {
          filesToAttach: [],
          filesToDrop: [],
        },
      }}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
};

TemplateTaskEditForm.propTypes = {
  taskId: PropTypes.number.isRequired,
  templateId: PropTypes.number.isRequired,
};
